<template>
    <div id="qg-toast">
        <Localeselect></Localeselect>
        <Browserextension></Browserextension>
        <Consent v-if="!ignoreConsentToast"></Consent>
        <UnpublishedPage></UnpublishedPage>
        <template v-if="Array.isArray(displayToasts)" v-for="toast in displayToasts">
            <Component :is="toast" :data="toastData[toast]" @dismiss-toast="dismissToast"></Component>
        </template>
    </div>
</template>

<script>
import Consent from '../../../../modules/sat/components/toasts/Consent';
import Localeselect from '../../../../modules/sat/components/toasts/Localeselect';
import Browserextension from '../../../../modules/sat/components/toasts/Browserextension';
import UnpublishedPage from '../../../../modules/sat/components/toasts/UnpublishedPage';
import ResultLimits from '../../../../../lib-sat/result/views/ResultLimits';
import { eventBus } from '../../../../../lib/event-bus/event-bus';
import { TOAST_HIDE, TOAST_APPEND, TOAST_SHOW, TOASTS } from './toast-consts';
import {projectHelper} from "../../../../../lib-sat/misc/project-helper";

const toastComponents = {
    [TOASTS.TOAST_RESULT_LIMITS]: ResultLimits,
    [TOASTS.TOAST_COOKIE_CONSENT]: Consent,
    [TOASTS.TOAST_LOCALE_SELECT]: Localeselect,
    [TOASTS.TOAST_BROWSER_EXTENSION]: Browserextension,
    [TOASTS.TOAST_UNPUBLISHED_PAGE]: UnpublishedPage,
};

export default {
    name: 'Toasts',
    components: toastComponents,
    created() {
        eventBus.listen(TOAST_APPEND, (toast) => {
            this.addToast(toast.name, toast.data);
        });

        eventBus.listen(TOAST_SHOW, (toast) => {
            if (this.displayToasts.includes(toast.name)) {
                // toast already exists, ignore
                return;
            }

            this.addToast(toast.name, toast.data);
        });

        eventBus.listen(TOAST_HIDE, (toast) => {
            this.dismissToast(toast);
        });
    },
    methods: {
        addToast(toastName, toastData) {
            if (!Object.keys(toastComponents).includes(toastName)) {
                // toast not found, ignore
                return;
            }

            if (toastData) {
                this.$set(this.toastData, toastName, toastData);
            }

            this.displayToasts.push(toastName);
        },
        dismissToast(toastName) {
            const toastIndex = this.displayToasts.indexOf(toastName);

            if (toastIndex === -1) {
                // toast not found, ignore
                return;
            }

            this.displayToasts.splice(toastIndex, 1);

            if (this.toastData[toastName]) {
                this.$delete(this.toastData, toastName);
            }
        },
    },
  computed: {
    ignoreConsentToast() {
      return true;
    }
  },
    data() {
        return {
            displayToasts: [],
            toastData: {},
        };
    },
};
</script>
